import { SelectionAlbum, SelectionPhoto, UserInfos } from "../../types/selection/selection";

export default class BaseSelectionProvider {
  hasAlbums(): boolean {
    return true;
  }
  hasMoreAlbums(): boolean {
    return false;
  }
  // eslint-disable-next-line
  hasMoreAlbumPhotos(albumRef: string): boolean {
    return false;
  }
  hasMorePhotos(): boolean {
    return false;
  }

  hasUserInfos(): boolean {
    return false;
  }

  isBlank(): boolean {
    return false;
  }

  refreshAlbums(): void {
    return;
  }
  refreshAlbumPhotos(): void {
    return;
  }
  refreshPhotos(): void {
    return;
  }

  async getAlbums(): Promise<SelectionAlbum[]> {
    return Promise.resolve([]);
  }

  async getMoreAlbums(): Promise<SelectionAlbum[]> {
    return Promise.resolve([]);
  }

  // eslint-disable-next-line
  async getAlbumPhotos(albumRef: string): Promise<SelectionPhoto[]> {
    return Promise.resolve([]);
  }

  // eslint-disable-next-line
  async getMoreAlbumPhotos(albumRef: string): Promise<SelectionPhoto[]> {
    return Promise.resolve([]);
  }

  async getPhotos(): Promise<SelectionPhoto[]> {
    return Promise.resolve([]);
  }

  async getMorePhotos(): Promise<SelectionPhoto[]> {
    return Promise.resolve([]);
  }

  async getUserInfos(): Promise<UserInfos> {
    return Promise.resolve({});
  }
}
